module.exports = __webpack_public_path__ + "static/Group6002@2x-cd8c64d028d681cb5f3412ab388306fb.png";